import React from "react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/+8619540597714" // ضع رقمك هنا مع كود الدولة
      className="btn btn-success rounded-circle shadow-lg position-fixed"
      style={{ bottom: "20px", right: "20px", zIndex: 9999, width: "60px", height: "60px" }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fab fa-whatsapp fs-2"></i>
    </a>
  );
}
